import { httpStatusCodes } from '../util/redux_resource_http_status_codes';
import { resourceReducer } from 'redux-resource';


export default resourceReducer('templates', { plugins: [ httpStatusCodes ] });
